export const initialProjectDirectory = "/view"